export default __webpack_public_path__ + "static/media/img_2.5a31c9f2.webp";